import React, { Component } from 'react';
import { connect } from 'react-redux';
import authUtils from '../../auth/utils';
import { loadLocalizations, fetchLocalization, updateLocalization, deleteLocalization } from './actions';
import LocalizationList from './List';
import SettingForm from './SettingsForm';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import { ConfirmationButton } from '../../common/components/formControls';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


class Localizations extends Component {
	constructor(props) {
		super(props);
		this.hideDialog = this.hideDialog.bind(this);
		this.showDialog = this.showDialog.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleDelete = this.handleDelete.bind(this);

		this.state = {
			showDialog: false
		};
	}

	componentDidMount() {
		this.reloadData();
	}

	reloadData() {
		const { resourceName } = this.props;
		this.props.loadEntities({ resourceName });
	}

	dialogConfig() {
		const { t, languages, isHtml, ...rest } = this.props;
		const { localization } = this.state;

		return {
			header: t('Localization_EditLocalization'),
			body: <SettingForm onSubmit={this.handleSave} initialValues={localization} isHtml={isHtml} languages={languages} {...rest} />,
			onHide: () => this.hideDialog(),
			footer: this.renderDialogFooter()
		};
	}

	hideDialog() {
		this.setState({ showDialog: false });
	}

	showDialog(localization) {
		this.setState({ showDialog: true, localization });
	}

	onSuccessEvent() {
		this.hideDialog();
		this.reloadData();
	}

	handleSave(values) {
		const onSuccessEvent = () => this.onSuccessEvent();

		const { updateLocalization, rootName, entityId, propertyName, languages } = this.props;

		values.cultureName = values.languageId;
		values.sourceId = entityId;
		values.propertyName = propertyName;
		updateLocalization(values, rootName, onSuccessEvent);
	}

	handleDelete() {
		const onSuccessEvent = () => this.onSuccessEvent();
		const { localization } = this.state;
		this.props.deleteLocalization(localization.id, onSuccessEvent);
	}

	renderDialogFooter() {
		const t = this.props.t;
		const { isReadonly } = this.props;

		const editMode = !!this.state.localization;
		const closeBtn = <Button key='close' onClick={this.hideDialog}>{t('Common_Close')}</Button>;
		const saveBtn = !isReadonly && < RemoteSubmitButton key='save' style='primary' formName='localization' label={t('Common_Save')} icon={faCheck} />;
		const deleteBtn = editMode && !isReadonly && <ConfirmationButton key='delete' onConfirmation={this.handleDelete} confirmationTitle={t('Localization_DeleteConfirmationTitle')}
			confirmationMessage={t('Localization_DeleteConfirmationMessage')} displayType={'inline'} style={{ marginLeft: '5px' }} label={t('Common_Delete')}></ConfirmationButton>;
		return [closeBtn, saveBtn, deleteBtn];
	}

	render() {
		const { t } = this.props;
		const { isReadonly, labelCol, valueCol, label } = this.props;
		const dialogConfig = this.dialogConfig();

		return (
			<div>
				<Dialog bsSize='large' config={dialogConfig} show={this.state.showDialog} enforceFocus={false} />
				<LocalizationList label={t('Localization_Localizations', { name: label })} data={this.props.data} onClick={this.showDialog} isReadonly={isReadonly}
					labelCol={labelCol} valueCol={valueCol} />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const rootName = ownProps.rootName;
	const entityId = ownProps.entityId;
	const propertyName = ownProps.propertyName;
	const resourceName = ownProps.resourceName;
	const isHtml = ownProps.isHtml;
	const isReadonlyParent = ownProps.isReadonly;
	const labelCol = ownProps.labelCol;
	const valueCol = ownProps.valueCol;

	const {
		entities: { localizations },
		lookups: { languages },
		auth: { currentUser }
	} = state;

	let allLocalizations = Object.values(localizations);
	let currentResourceLocalizations = allLocalizations.filter((localization) => localization.resourceName == resourceName);

	return {
		data: currentResourceLocalizations,
		rootName: rootName,
		entityId: entityId,
		propertyName: propertyName,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Localizations') || isReadonlyParent,
		languages: languages,
		isHtml: isHtml,
		labelCol,
		valueCol
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadLocalizations,
	deleteLocalization,
	fetchLocalization,
	updateLocalization
})(withTranslation()(Localizations));